<template>
  <div>
    <vue-product-spinner
        :images="dataImages"
        :slider="true"
        :infinite="false"
    >
    </vue-product-spinner>
  </div>
</template>

<script>
import VueProductSpinner from "vue-product-spinner";

export default {
  components: {
    "vue-product-spinner": VueProductSpinner
  },
  props: ['dataImages'],
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>

